module.exports = __webpack_public_path__ + "media/bootstrap-icons/arrow-up-right-circle-7a01f0f8.svg";